// Footer — footer de 4 columnas de la tienda v5 (Comprar · Info · Comunidad · Contacto).
// Fuente: maquetas/tienda-v5-*.html (versión con hrefs reales — cierra el drift de links muertos).
// Comunidad incluye Programa Cuadra. Contacto: WhatsApp (fill), mail (fill), Instagram (fill).
// Copy centrado: copyright + misión.
//
// Self-contained: <style>{FOOTER_CSS}</style> + clases .tv5-ft-* + tokens --tv5-* propios.
//
// Props:
//   accent  'teal'|'gold'  → color de los h4 y hovers (Tienda usa gold). default 'teal'
import { Link } from 'react-router-dom';
import { TV5_ROUTES, TV5_EXTERNAL } from './routes';

const FOOTER_CSS = `
.tv5-ft {
  --tv5-teal:#00A8B5; --tv5-gold:#C5A059; --tv5-accent:var(--tv5-teal);
  --tv5-text:#F8F6F1; --tv5-muted:rgba(248,246,241,0.65); --tv5-dim:rgba(248,246,241,0.45);
  --tv5-border:rgba(255,255,255,0.08);
  margin-top:60px; padding:32px 20px 40px; border-top:1px solid var(--tv5-border);
  background:rgba(0,0,0,0.2);
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-ft--gold { --tv5-accent:var(--tv5-gold); }
.tv5-ft-grid { max-width:1200px; margin:0 auto; display:grid; grid-template-columns:repeat(2,1fr); gap:24px; align-items:start; }
@media (min-width:640px){ .tv5-ft-grid { grid-template-columns:repeat(4,1fr); gap:32px; } }
.tv5-ft-col h4 { font-size:11px; font-weight:800; letter-spacing:0.1em; text-transform:uppercase; color:var(--tv5-accent); margin-bottom:12px; }
.tv5-ft-col a { display:block; color:var(--tv5-muted); text-decoration:none; font-size:12px; margin-bottom:10px; line-height:1.4; min-height:20px; }
/* Contacto: selector con especificidad >= '.tv5-ft-col a' para que el flex NO quede pisado
   (antes ganaba display:block y los íconos/links quedaban apretados). */
.tv5-ft-col a.tv5-ft-contacto { display:flex; align-items:center; gap:8px; width:fit-content; line-height:1.4; min-height:22px; margin-bottom:12px; }
.tv5-ft-contacto svg { flex-shrink:0; opacity:0.9; }
.tv5-ft-contacto.wa svg { color:#25D366; }
.tv5-ft-contacto.ig svg { color:#E1306C; }
.tv5-ft-contacto.mail svg { color:var(--tv5-teal); }
.tv5-ft-copy { text-align:center; color:var(--tv5-dim); font-size:12px; margin-top:20px; }
.tv5-ft-mission { text-align:center; color:var(--tv5-dim); font-size:12px; margin:8px auto 0; max-width:520px; line-height:1.5; opacity:0.7; padding:0 20px; }
@media (hover:hover){ .tv5-ft-col a:hover { color:var(--tv5-text); } }
.tv5-ft-legal { display:flex; flex-wrap:wrap; justify-content:center; gap:8px 18px; margin:24px auto 0; max-width:1200px; padding-top:18px; border-top:1px solid var(--tv5-border); }
.tv5-ft-legal a { color:var(--tv5-muted); font-size:12px; text-decoration:none; min-height:20px; }
@media (hover:hover){ .tv5-ft-legal a:hover { color:var(--tv5-text); } }
`;

export function Footer({ accent = 'teal' }) {
  return (
    <footer className={'tv5-ft' + (accent === 'gold' ? ' tv5-ft--gold' : '')}>
      <style>{FOOTER_CSS}</style>
      <div className="tv5-ft-grid">
        <div className="tv5-ft-col">
          <h4>Comprar</h4>
          <Link to={TV5_ROUTES.home}>Home</Link>
          <Link to={TV5_ROUTES.kits}>Kits mensuales</Link>
          <Link to={TV5_ROUTES.tienda}>Tienda</Link>
        </div>
        <div className="tv5-ft-col">
          <h4>Info</h4>
          <Link to={TV5_ROUTES.comoFunciona}>Cómo funciona</Link>
          <Link to={TV5_ROUTES.barrios}>Barrios</Link>
          <Link to={TV5_ROUTES.faq}>FAQ</Link>
                  <a href="https://limpack.uy/terminos">Términos y condiciones</a>
          <a href="https://limpack.uy/terminos#devoluciones">Cambios y devoluciones</a>
          <a href="https://limpack.uy/privacidad">Privacidad</a>
        </div>
        <div className="tv5-ft-col">
          <h4>Comunidad</h4>
          <Link to={TV5_ROUTES.porteros}>Porteros</Link>
          <Link to={TV5_ROUTES.empresas}>Empresas</Link>
          <Link to={TV5_ROUTES.cuadra}>Programa Cuadra</Link>
          <Link to={TV5_ROUTES.quienesSomos}>Quiénes somos</Link>
        </div>
        <div className="tv5-ft-col">
          <h4>Contacto</h4>
          <a href={TV5_EXTERNAL.whatsapp} target="_blank" rel="noopener" className="tv5-ft-contacto wa">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            WhatsApp
          </a>
          <a href={TV5_EXTERNAL.mail} className="tv5-ft-contacto mail">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
            hola@limpack.uy
          </a>
          <a href={TV5_EXTERNAL.instagram} target="_blank" rel="noopener" className="tv5-ft-contacto ig">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            Instagram
          </a>
        </div>
      </div>
      <div className="tv5-ft-legal">
        <a href={TV5_ROUTES.terminos}>Términos y condiciones</a>
        <a href={TV5_ROUTES.terminos}>Cambios y devoluciones</a>
        <a href={TV5_ROUTES.privacidad}>Privacidad</a>
      </div>
      <div className="tv5-ft-copy">© 2026 Limpack SAS · Montevideo, Uruguay</div>
      <div className="tv5-ft-mission">Probamos cada producto que te vendemos. El sitio, la app y todo el resto — también lo hacemos nosotros.</div>
    </footer>
  );
}
